import {
    actionSetCurrentProduct,
    actionSetCurrentProductSeo,
    actionSetProductCounterCount,
} from 'modules/product-card/slice';
import {TAppThunk} from 'core/redux/types';
import {TProductResponse} from 'modules/product-card/models/ProductResponse';
import {IGetReviewsTotalRequest, TGetReviewsTotalResponse} from '../models/Review';
import {getProduct, getReviewsTotal as getReviewsTotalAction} from '../services';

export const getReviewsTotal =
    (params: IGetReviewsTotalRequest): TAppThunk<TGetReviewsTotalResponse['data'] | undefined> =>
    async (dispatch) => {
        if (!params?.filter?.code) {
            return undefined;
        }

        const result = await dispatch(getReviewsTotalAction.initiate(params));

        return result.data;
    };

interface IGetProductByIdProps {
    code: string;
}

export const getProductByCode =
    ({code}: IGetProductByIdProps): TAppThunk<TProductResponse | undefined> =>
    async (dispatch) => {
        try {
            if (!code) {
                return undefined;
            }

            const {data} = await dispatch(getProduct.initiate(code, {forceRefetch: true}));

            dispatch(actionSetCurrentProduct(data?.data ?? null));
            dispatch(actionSetCurrentProductSeo(data?.seo ?? null));
            return data;
        } catch (e) {
            console.error(e);
            return undefined;
        }
    };

export const setProductCounterCount =
    (count: number): TAppThunk<void> =>
    async (dispatch) => {
        dispatch(actionSetProductCounterCount(count));
    };
